import React, { useEffect, useState } from 'react';
import { SkeletonContent, SkeletonLine } from '@one-thd/sui-atomic-components';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { StartAReturn } from '../order-actions/returns/StartAReturn';
import { useOrderDetailsContext } from '../../../hooks/useContexts';
import { hasEligibleFGs, hasFailedSTHDeliveryTracker, separateAndCrosscheckSTHFGs, } from '../../../utils/returns/returns-helper';
var SingleStartAReturn = function (_a) {
    var _b;
    var orderDetailsData = _a.orderDetailsData, guestOrderTrackingRoute = _a.guestOrderTrackingRoute;
    var disableStartAReturn = Boolean(FeatureSwitches.disableStartAReturn);
    var nonGuestDeliveryTrackerLoaded = useOrderDetailsContext().deliveryTrackerLoaded;
    var isDeliveryTrackerLoaded = guestOrderTrackingRoute
        ? true
        : nonGuestDeliveryTrackerLoaded;
    var _c = useState(false), showSAR = _c[0], setShowSAR = _c[1];
    var enableDeliveryTrackerReturnChanges = FeatureSwitches.enableDeliveryTrackerReturnChanges;
    // Check if STH FG is present to see if showSAR needs to wait for delivery tracker calls
    var hasSTHFulfillmentGroup = (_b = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.fulfillmentGroups) === null || _b === void 0 ? void 0 : _b.some(function (fg) { return fg.fulfillmentType === FULFILLMENT_TYPE.STH; });
    useEffect(function () {
        // If there is no STH FG then we don't have to wait for delivery tracker calls, just use OMS's eligibility flags
        if (!enableDeliveryTrackerReturnChanges || !hasSTHFulfillmentGroup) {
            var _a = (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.actions) || {}, returnOnlineAllowed = _a.returnOnlineAllowed, returnInStoreAllowed = _a.returnInStoreAllowed, returnLORPAllowed = _a.returnLORPAllowed;
            var shouldShowSAR = returnOnlineAllowed || returnInStoreAllowed || returnLORPAllowed;
            setShowSAR(shouldShowSAR);
        }
    }, [orderDetailsData]);
    useEffect(function () {
        if (enableDeliveryTrackerReturnChanges &&
            hasSTHFulfillmentGroup &&
            isDeliveryTrackerLoaded) {
            // Check if any STH delivery tracker call failed by checking if tracker data is null, if so then SAR button should remain hidden
            if (hasFailedSTHDeliveryTracker(orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.fulfillmentGroups)) {
                setShowSAR(false);
                return;
            }
            // Check OMS FG eligibilities and crosscheck with STH delivery tracker FG-level flags
            var _a = separateAndCrosscheckSTHFGs(orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.fulfillmentGroups), updatedSthFGs = _a.updatedSthFGs, nonSthFGs = _a.nonSthFGs;
            // Check if either sth or non-sth FGs have returnOnlineAllowed, returnInStoreAllowed, or returnLORPAllowed set to true
            if (hasEligibleFGs(updatedSthFGs) || hasEligibleFGs(nonSthFGs)) {
                setShowSAR(true);
            }
            else {
                // Otherwise hide button in case no FGs are eligible
                setShowSAR(false);
            }
        }
    }, [isDeliveryTrackerLoaded]);
    var SkeletonLoader = function () { return (React.createElement("div", { className: "sui-w-full md:sui-max-w-[50%]" },
        React.createElement("div", { className: "sui-mb-4", "data-testid": "skeleton-loader" },
            React.createElement(SkeletonContent, { disablePadding: true, disableGutters: true, initialSize: "full" },
                React.createElement(SkeletonLine, { variant: "single", fullWidth: true }))))); };
    // Do not render component at all if FS turns it off
    if (disableStartAReturn) {
        return null;
    }
    // Only show skeleton loader when feature switch is enabled and waiting for delivery tracker
    if (enableDeliveryTrackerReturnChanges &&
        hasSTHFulfillmentGroup &&
        !isDeliveryTrackerLoaded) {
        return React.createElement(SkeletonLoader, null);
    }
    return (React.createElement(React.Fragment, null, showSAR && (React.createElement("div", { className: "sui-w-full sui-max-w-[400px] sui-mb-[16px]" },
        React.createElement(StartAReturn, { buttonVariant: "secondary", icon: true, orderDetailsData: orderDetailsData, orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber, tenders: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.tenders, isGuest: guestOrderTrackingRoute, name: "Start a Return" })))));
};
export default SingleStartAReturn;
